define('v3/Common/Components/SubjectGroupsDropdown/Services/subjectGroupService',[
	'lodash',
	'v3/Common/Services/Backend/subjectGroupBackend',
	'v3/FromV2/localStorageV3Service'
], function (_, subjectGroupBackend, cookieService) {
	return {
		getSubjectGroupsWhereEducationPlanExists: _.memoize(function () {
			return subjectGroupBackend.getSubjectGroupsWhereEducationPlanExists();
		}),

		getPupilSubjectGroupsWhereEducationPlanExists: function (pupilId) {
			return subjectGroupBackend.getPupilSubjectGroupsWhereEducationPlanExists(pupilId);
		},

		getPupilSubjectGroupIdsWhereEducationPlanExists: function (pupilId) {
			return subjectGroupBackend.getPupilSubjectGroupIdsWhereEducationPlanExists(pupilId);
		},

		getAllSubjectGroups: _.memoize(function () {
			return subjectGroupBackend.getAllSubjectGroups();
		}),
		getSubjectGroupGradeDetails: function (subjectGroupId) {
			return subjectGroupBackend.getSubjectGroupGradeDetails(subjectGroupId);
		},
		saveSubjectGroupId: function (subjectGroupId) {
			cookieService.setSubjectGroupFilterStateLocalStorage({ subjectGroupIdFilter: subjectGroupId });
		},
		clearSubjectGroupId: function () {
			cookieService.setSubjectGroupFilterStateLocalStorage(null);
		},
		getSubjectGroupId: function () {
			var subjectGroupFilterState = cookieService.getSubjectGroupFilterStateLocalStorage();
			if (subjectGroupFilterState) {
				return subjectGroupFilterState.subjectGroupIdFilter;
			}
			return null;
		}
	};
});
